import "./App.css";
import { history } from "./history";
import { Router, Switch, Route } from "react-router-dom";
import { Helmet } from "react-helmet";

import React, { useState, lazy, Suspense, createContext } from "react";
import Header from "./components/Header";
import Sidebar from "./components/SideBar/Sidebar";
// import { DieselRequestList } from "./components/FuelReports/dieselRequestList";
import ConvertpdfPage from "./components/VehicleManagement/ConvertpdfPage";
// import SubscriptionList from "./components/Subscription_master/SubscriptionList";
// import VehicleCertificate from "./components/VehicleManagement/VehicleCertificate";
// import ViewCertificatesData from "./components/VehicleManagement/ViewCertificatesData";
// import { PrivateRoute } from './route/privateRoute';
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import { ThemeContext } from "@emotion/react";
import NotificationComponent from "./components/NotificationManagment/NotificationListener";
import PayDemo from "./components/Customer_Activation_Renewal/PayDemo";
import { ToastProvider } from "./components/CommonComponents/useToast";
import LockInventory from "./components/LockInventory";
import DashcamVideo from "./components/DashCam/DashcamLayout";
import ManualTripReport from "./components/ReportsLock/ManualTripReport";
import SystemGeneratedTripReport from "./components/ReportsLock/SystemGeneratedTripReport";
import LockUnlockReport from "./components/ReportsLock/Lockunlockreport";
import HistoryReport from "./components/ReportsGps/HistoryReport";
import FmsDashboard from "./components/FmsDashboard";
import FuelSummaryReport from "./components/FMSReports/fuelSummaryReport";
import FuelFillReport from "./components/FMSReports/fuelFillReport";
import FuelDroppageReport from "./components/FMSReports/fuelDroppageReport";

const Login = lazy(() => import("./components/Login"));
const UserList = lazy(() => import("./components/UserManagement/userList"));
const AddUser = lazy(() => import("./components/UserManagement/addUser"));
const Users = lazy(() => import("./components/UserManagement/viewUser"));
const SubUserList = lazy(
  () => import("./components/UserManagement/SubUserManagement/subUserList"),
);
const AddSubUser = lazy(
  () => import("./components/UserManagement/SubUserManagement/addSubUser"),
);
const VehicleCertificate = lazy(
  () => import("./components/VehicleManagement/VehicleCertificate"),
);
const SubUsers = lazy(
  () => import("./components/UserManagement/SubUserManagement/viewSubUser"),
);
const CompanyList = lazy(
  () => import("./components/CompanyManagement/companyList"),
);
const AddCompany = lazy(
  () => import("./components/CompanyManagement/addCompany"),
);
const AddSite = lazy(() => import("./components/Site/addSite"));
const VehicleList = lazy(
  () => import("./components/VehicleManagement/vehicleList"),
);const smsLogs = lazy(
  () => import("./components/smsLogs/index"),
);
const AddVehicle = lazy(
  () => import("./components/VehicleManagement/addVehicle"),
);

const CustomerVehicleList = lazy(
  () => import("./components/Customer_Vehicle_Management/vehicleList"),
);
const CustomerAddVehicle = lazy(
  () => import("./components/Customer_Vehicle_Management/addVehicle"),
);
const VendorList = lazy(
  () => import("./components/VendorManagement/vendorList"),
);
const AddVendor = lazy(() => import("./components/VendorManagement/addVendor"));
const Vehicles = lazy(
  () => import("./components/VehicleManagement/viewVehicle"),
);

const CustomerVehicles = lazy(
  () => import("./components/Customer_Vehicle_Management/viewVehicle"),
);

const KycMaster = lazy(() => import("../src/components/KycMaster/KycMaster"));
const Vendors = lazy(() => import("./components/VendorManagement/viewVendor"));
const RouteList = lazy(() => import("./components/RouteManagement/routeList"));
// const AddRoute = lazy(() => import("./components/RouteManagement/addRoute"));
const ViewRoute = lazy(() => import("./components/RouteManagement/viewRoute"));
const TripList = lazy(() => import("./components/TripManagement/tripList"));
const ViewTrip = lazy(() => import("./components/TripManagement/viewTrip"));
const AddTrip = lazy(() => import("./components/TripManagement/addTrip"));
const Reports = lazy(() => import("./components/Reports/report"));
const LoginlogReport = lazy(
  () => import("./components/Reports/LoginlogReport"),
);
const SiteManagement = lazy(() => import("./components/Site/siteManagement"));
const ViewUser = lazy(() => import("./components/Site/viewUser"));
const LiveTracking = lazy(() => import("./components/Tracking/live"));
const HistoryTracking = lazy(() => import("./components/Tracking/history"));
const NewHistory = lazy(() => import("./components/Tracking/NewHistory"));
const DriverManagement = lazy(
  () => import("./components/DriverManagement/DriverManagement"),
);
const AddDriver = lazy(() => import("./components/DriverManagement/AddDriver"));
const ViewDriver = lazy(
  () => import("./components/DriverManagement/ViewDriver"),
);
const Dashboard = lazy(() => {
  window.open("/", "_self");
  import("./components/Dashboard/dashboard");
});

const AllReportPage = lazy(
  () => import("./components/ReportsGps/AllReportPage"),
);
// const FuelReport = lazy(() => import("./components/FuelReports/report"));
// // const FuelDashboard = lazy(() => import("./components/FuelReports/dashboard"));
// const FuelDashboard = lazy(() =>
//   import("./components/FuelReports/fuelDashboard")
// );
const KMLView = lazy(() => import("./components/kmlFile/index"));
const Alerts = lazy(() => import("./components/Alerts/index"));
const SummaryReportPage = lazy(
  () => import("./components/ReportsGps/SummaryReportPage"),
);
const DailyDistanceReport = lazy(
  () => import("./components/ReportsGps/DailyDistanceReport"),
);
const StoppageReport = lazy(
  () => import("./components/ReportsGps/StoppageReport"),
);
const MovementReportPage = lazy(
  () => import("./components/ReportsGps/Movement"),
);
const StopReportPage = lazy(
  () => import("./components/ReportsGps/StopReportPage"),
);
const IdleReportPage = lazy(
  () => import("./components/ReportsGps/IdleReportPage"),
);
const TripReportPage = lazy(
  () => import("./components/ReportsGps/TripReportPage"),
);
const EventReportPage = lazy(
  () => import("./components/ReportsGps/EventReportPage"),
);
const tripMap = lazy(() => import("./components/TripManagement/tripMaps"));
const ReportMapDetails = lazy(
  () => import("./components/Reports/reportMapDetails"),
);
// const FuelVehicleDetail = lazy(() =>
//   import("./components/FuelReports/fuelVehicleDetail")
// );
// const SensorWirecut = lazy(() =>
//   import("./components/FuelReports/SensorWirecut")
// );
const NotificationConfiguration = lazy(
  () => import("./components/ConfigureManagement/Notification_Configuration"),
);
const NotificationConfigurations = lazy(
  () => import("./components/NotificationsConfigurations/notification"),
);
const AddNotification = lazy(
  () =>
    import("./components/ConfigureManagement/add_notication/Add_Notification_Configuration"),
);
// const Dieselissue = lazy(() => import("./components/FuelReports/Diesel_issue"));
// const Requste = lazy(() => import("./components/FuelReports/Requester"));
const RoleList = lazy(() => import("./components/SideBar/RoleList/Rolelist"));
const VehicleActivation = lazy(
  () => import("./components/VehicleActivation/VehicleActivation"),
);
const SubscriptionList = lazy(
  () => import("./components/Subscription_master/SubscriptionList"),
);
const DealerLedgerList = lazy(
  () => import("./components/DealerLedger/dealerLedgerList"),
);
const DealerDetails = lazy(
  () => import("./components/DealerLedger/dealerDetails"),
);
// const DealerDetails = lazy(() =>
//   import("./components/Activation_Renewal/DealerDetails")
// );
const ActivationRenewalList = lazy(
  () => import("./components/Activation_Renewal/activatiRenewalList"),
);
const AddActivationRequest = lazy(
  () => import("./components/Activation_Renewal/addActivationrenewalRequest"),
);
const ActivationByidDetails = lazy(
  () => import("./components/Activation_Renewal/activationByidDetails"),
);
const CustomerActivationRenewalList = lazy(
  () => import("./components/Customer_Activation_Renewal/activatiRenewalList"),
);
const CustomerAddActivationRequest = lazy(
  () =>
    import("./components/Customer_Activation_Renewal/addActivationrenewalRequest"),
);
const CustomerActivationByidDetails = lazy(
  () =>
    import("./components/Customer_Activation_Renewal/activationByidDetails"),
);

const UpdateDate = lazy(
  () => import("./components/Activation_Renewal/updateDate"),
);
const VehicleDashboard = lazy(
  () => import("./components/VehicleDetailsDashboard/Dashboard"),
);

const CustomerDashboard = lazy(
  () => import("../src/components/CustomerDashboard/dashboard"),
);
const RoleManagement = lazy(
  () => import("./components/RolesManagement/RoleManagement"),
);

const GeofenceList = lazy(() => import("./components/Geofence/geofenceList"));
const AddFPL = lazy(() => import("./components/Geofence/addSite"));
// const NotificationConfiguration=lazy(()=>
// import("./components/")
// );
const MapView = lazy(() => import("./components/MapView/MapView"));
const LiveTrackingMapView = lazy(
  () => import("./components/MapView/liveTracking"),
);

const StatsDashboard = lazy(() => import("./components/Stats_Dashboard/index"));

const TerritoryAndZoneManagement = lazy(
  () =>
    import("./components/TerritoryAndZoneManagement/TerritoryAndZoneManagement"),
);
const RouteConfiguration = lazy(
  () => import("./components/RouteConfiguration"),
);
const AddRoute = lazy(() => import("./components/RouteConfiguration/addRoute"));
const TripConfiguration = lazy(() => import("./components/TripConfiguration"));
const AddDigitalLockTrip = lazy(
  () => import("./components/TripConfiguration/addDigitalLockTrip"),
);
const ViewDigitalLockTrip = lazy(
  () => import("./components/TripConfiguration/TripView"),
);

const PermissionController = lazy(() => import("./components/PermissionController/index"))

export const themeContext = createContext({ color: "#542f85" });
console.log(themeContext);
const color =
  (localStorage.getItem("config") &&
    JSON.parse(localStorage.getItem("config")) &&
    JSON.parse(localStorage.getItem("config")).datas &&
    JSON.parse(JSON.parse(localStorage.getItem("config")).datas)?.color) ||
  "#542f85";

const dynamicFaviconUrl =
  localStorage.getItem("config") &&
  JSON.parse(localStorage.getItem("config")).logoUrl;

// const dynamicFaviconUrl="https://eclvts.com/resources/psdn.jpeg"
console.log(dynamicFaviconUrl);
const darkenColor = (hexColor, percent) => {
  // Parse hex color to RGB
  // Remove the hash if it's present
  const hex = hexColor.replace(/^#/, "");

  // Parse the hex values for each color component
  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  // Return the RGB values as an object
  // return { r, g, b };

  // Darken the color (adjust the percentage as needed)
  const darkenAmount = 1 - percent / 100;
  const darkenedColor = `#${Math.round(r * darkenAmount).toString(
    16,
  )}${Math.round(g * darkenAmount).toString(16)}${Math.round(
    b * darkenAmount,
  ).toString(16)}`;
  console.log(darkenedColor);
  return darkenedColor;
};
console.log(color && color);
const theme = createTheme({
  overrides: {
    // Style sheet name ⚛️
    MuiButton: {
      // Name of the rule
      contained: {
        // Some CSS
        color: "white",
        backgroundColor: color || "#542f85",
        "&:hover": {
          backgroundColor: color ? darkenColor(color, 95) : "#542f85",
        },
      },
    },
  },
});

function App() {
  const [themeColor, setThemeColor] = useState(color || "#47296b");
  const [events, setEvents] = useState([]);
  const handleSetEvents = (newEvents) => {
    setEvents(newEvents);
  };

  // componentDidMount() {
  //   // window.location.hostname=='ioclfleet'?document.title = "IOCL":document.title = "NKC"
  // }

  return (
    <main className="App">
      {/* <Helmet>
        <link rel="icon" href={dynamicFaviconUrl} type="image/x-icon" />
      </Helmet> */}
      <themeContext.Provider value={{ color: themeColor }}>
        <ToastProvider>
          <ThemeProvider theme={theme}>
            <Router history={history}>
              {window.location.pathname !== "/" &&
                window.location.pathname !== "/alerts" &&
                window.location.pathname.split("/")[1] !==
                "VehicleCertificate" &&
                window.location.pathname !== "/ViewCertificatesData" && (
                  <>
                    <Header events={events} setEvents={setEvents} />
                    <Sidebar />
                    <NotificationComponent setEvents={handleSetEvents} />
                  </>
                )}

              <Suspense fallback={<div>Loading</div>}>
                <Switch>
                  <Route exact path="/" component={Login} />
                  <Route exact path="/userlist" component={UserList} />
                  <Route exact path="/adduser" component={AddUser} />
                  <Route exact path="/users/:id?" component={Users} />
                  <Route exact path="/subuserlist" component={SubUserList} />
                  <Route exact path="/addsubuser" component={AddSubUser} />
                  <Route exact path="/subusers/:id" component={SubUsers} />
                  <Route exact path="/companylist" component={CompanyList} />
                  <Route exact path="/addcompany" component={AddCompany} />
                  <Route exact path="/vehiclelist" component={VehicleList} />
                  <Route exact path="/addvehicle" component={AddVehicle} />
                  <Route exact path="/vehicles/:id?" component={Vehicles} />
                  <Route
                    exact
                    path="/CustomerVehicleList"
                    component={CustomerVehicleList}
                  />
                  <Route
                    exact
                    path="/CustomerAddVehicle"
                    component={CustomerAddVehicle}
                  />
                  <Route
                    exact
                    path="/CustomerVehicles/:id?"
                    component={Vehicles}
                  />

                  <Route exact path="/transporters/:id?" component={Vendors} />
                  <Route exact path="/kycMaster" component={KycMaster} />
                  <Route exact path="/transporterlist" component={VendorList} />
                  <Route exact path="/addtransporter" component={AddVendor} />
                  <Route
                    exact
                    path="/routelist"
                    component={RouteConfiguration}
                  />
                  <Route exact path="/addroute" component={AddRoute} />
                  <Route exact path="/routes/:id?" component={ViewRoute} />
                  <Route exact path="/triplist" component={TripList} />
                  <Route
                    exact
                    path="/DigitalLockTrips"
                    component={TripConfiguration}
                  />
                  <Route
                    exact
                    path="/addDigitalLockTrip"
                    component={AddDigitalLockTrip}
                  />
                  <Route
                    exact
                    path="/tripView"
                    component={ViewDigitalLockTrip}
                  />

                  <Route exact path="/addtrip" component={AddTrip} />
                  <Route exact path="/trips/:id?" component={ViewTrip} />
                  <Route exact path="/reports" component={Reports} />
                  <Route exact path="/sitelist" component={SiteManagement} />
                  <Route exact path="/viewUser/:id?" component={ViewUser} />
                  <Route exact path="/site/:id?" component={AddSite} />
                  <Route exact path="/addSite" component={AddSite} />
                  <Route exact path="/live/:id?" component={LiveTracking} />
                  <Route
                    exact
                    path="/history/:id?"
                    component={HistoryTracking}
                  />
                  <Route exact path="/travelJourney" component={NewHistory} />
                  <Route exact path="/dashboard" component={Dashboard} />
                  <Route exact path="/Reportsgps" component={AllReportPage} />
                  {/* <Route exact path="/fuelReport" component={FuelReport} /> */}
                  {/* <Route exact path="/fuelDashboard" component={FuelDashboard} /> */}
                  <Route exact path="/kmlview" component={KMLView} />
                  <Route exact path="/alerts" component={Alerts} />
                  <Route exact path="/Summary" component={SummaryReportPage} />
                  <Route
                    exact
                    path="/Movement"
                    component={MovementReportPage}
                  />
                  <Route exact path="/Stoppage" component={StopReportPage} />
                  <Route exact path="/IdleReport" component={IdleReportPage} />
                  <Route
                    exact
                    path="/reportDetails"
                    component={ReportMapDetails}
                  />
                  <Route exact path="/tripTrack/:id?" component={tripMap} />
                  <Route exact path="/audit" component={Reports} />
                  <Route
                    exact
                    path="/Loginlogaudit"
                    component={LoginlogReport}
                  />
                  <Route exact path="/activeRoutes" component={Reports} />
                  <Route exact path="/upTime" component={Reports} />
                  <Route
                    exact
                    path="/VehicleCertificate/:certificateNo?"
                    component={VehicleCertificate}
                  />
                  {/* <Route
                exact
                path="/ViewCertificatesData"
                component={ViewCertificatesData}
              /> */}
                  {/* <Route
                exact
                path="/fuelDetails/:id?"
                component={FuelVehicleDetail}
              /> */}
                  <Route
                    exact
                    path="/notificationConfigure"
                    component={NotificationConfiguration}
                  />
                  <Route
                    exact
                    path="/NotificationConfigurations"
                    component={NotificationConfigurations}
                  />
                  <Route
                    exact
                    path="/addNotification"
                    component={AddNotification}
                  />
                  <Route
                    exact
                    path="/viewNotification/:id?"
                    component={AddNotification}
                  />
                  {/* <Route exact path="/SensorWirecut" component={SensorWirecut} /> */}
                  {/* <Route exact path="/Diesel_issue" component={DieselRequestList} /> */}
                  {/* {/ <Route exact path="/Requester" component={Requester} /> /} */}
                  <Route exact path="/rolelist" component={RoleList} />
                  <Route
                    exact
                    path="/VehicleActivation"
                    component={VehicleActivation}
                  />
                  <Route
                    exact
                    path="/SubscriptionMaster"
                    component={SubscriptionList}
                  />
                  <Route
                    exact
                    path="/dealerLedger"
                    component={DealerLedgerList}
                  />
                  <Route
                    exact
                    path="/driverlist"
                    component={DriverManagement}
                  />
                  <Route exact path="/addDriver" component={AddDriver} />
                  <Route exact path="/viewDriver" component={ViewDriver} />
                  <Route
                    exact
                    path="/dealerDetails/:id?"
                    component={DealerDetails}
                  />
                  <Route
                    exact
                    path="/activationRenewalList"
                    component={ActivationRenewalList}
                  />
                  <Route exact path="/updateDate" component={UpdateDate} />

                  <Route
                    exact
                    path="/addNewRequest/:requestType"
                    component={AddActivationRequest}
                  />
                  <Route
                    exact
                    path="/ActivationByIdDetails/:id?"
                    component={ActivationByidDetails}
                  />
                  {/* customer activation renewal path */}
                  <Route
                    exact
                    path="/CustomerActivationRenewalList"
                    component={CustomerActivationRenewalList}
                  />

                  <Route
                    exact
                    path="/customerAddNewRequest/:requestType"
                    component={CustomerAddActivationRequest}
                  />
                  <Route
                    exact
                    path="/CustomerActivationByidDetails/:id?"
                    component={CustomerActivationByidDetails}
                  />

                  <Route exact path="/pay" component={PayDemo} />

                  {/* -------------------------------- */}

                  <Route
                    exact
                    path="/VehicleDashboard"
                    component={VehicleDashboard}
                  />
                  <Route
                    exact
                    path="/RoleManagement"
                    component={RoleManagement}
                  />
                  <Route
                    exact
                    path="/customer-dashboard"
                    component={VehicleDashboard}
                  />
                  {/* ========ais-user-geofence============================ */}
                  <Route exact path="/geofencelist" component={GeofenceList} />
                  <Route exact path="/geofence/:id?" component={AddFPL} />
                  <Route exact path="/addgeofence" component={AddFPL} />
                  {/* ====================================================== */}
                  <Route exact path="/mapView" component={MapView} />
                  <Route
                    exact
                    path="/liveTracking/:id"
                    component={LiveTrackingMapView}
                  />

                  <Route
                    exact
                    path="/stats-dashboard"
                    component={StatsDashboard}
                  />
                  <Route
                    exact
                    path="/DailyDistanceReport"
                    component={DailyDistanceReport}
                  />
                  <Route
                    exact
                    path="/StoppageReport"
                    component={StoppageReport}
                  />
                  <Route exact path="/TripReport" component={TripReportPage} />
                  <Route
                    exact
                    path="/EventReport"
                    component={EventReportPage}
                  />
                  <Route
                    exact
                    path="/HistoryReport"
                    component={HistoryReport}
                  />
                  <Route
                    exact
                    path="/TerritoryAndZoneManagement"
                    component={TerritoryAndZoneManagement}
                  />
                  <Route
                    exact
                    path="/LockConfigurations"
                    component={LockInventory}
                  />
                  <Route
                    exact
                    path="/dashcamVideo"
                    component={DashcamVideo}
                  />
                  <Route exact path="/manualTripReport" component={ManualTripReport} />
                  <Route exact path="/systemGeneratedTripReport" component={SystemGeneratedTripReport} />
                  <Route exact path="/lockUnlockReport" component={LockUnlockReport} />
                  <Route exact path="/permissionController" component={PermissionController} />
                  <Route path="/fmsDashboard" component={FmsDashboard} />
                  <Route path="/fuelSummaryReport" component={FuelSummaryReport} />
                  <Route path="/fuelFillReport" component={FuelFillReport} />
                  <Route path="/fuelDroppageReport" component={FuelDroppageReport} />
                  <Route path="/smsLogs" component={smsLogs} />
                </Switch>
              </Suspense>
            </Router>




          </ThemeProvider>
        </ToastProvider>
      </themeContext.Provider>
    </main>
  );
}
export default App;
